export const SALSA_AUTH_TOKEN_EMPLOYER = "salsaAuthTokenEmployer";
export const SALSA_AUTH_TOKEN_WORKER = "salsaAuthTokenWorker";
export const SALSA_AUTH_TOKEN_REQUEST_DATETIME = "salsaAuthTokenRequestDateTime";
